export {
  DeckItemNoteFileUpload,
  DeckItemNoteFileUploadProps,
} from './DeckItemNoteFileUpload';
